(() => {
  const configNode = document.getElementById('pad-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const weekday = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  function serviceState(now = new Date()) {
    const parts = Object.fromEntries(weekday.formatToParts(now).map(p => [p.type,p.value]));
    const scheduled = (parts.weekday === 'Sat' && config.saturday) || (parts.weekday === 'Sun' && config.sunday);
    const minute = Number(parts.hour) * 60 + Number(parts.minute);
    const openHour=Number(config.opens), closeHour=Number(config.closes), cutoff=Number(config.cutoff);
    const cafeOpen=Boolean(scheduled && closeHour>openHour && minute>=openHour*60 && minute<closeHour*60);
    const accepts=Boolean(config.enabled && !config.paused && cafeOpen && minute<closeHour*60-cutoff);
    const reason=!config.enabled?(config.message || config.unavailable):config.paused?config.paused_text:!accepts?config.closed:'';
    return {accepts,cafeOpen,reason};
  }
  function refresh() {
    const state=serviceState();
    document.querySelectorAll('[data-pad-service-status],[data-pad-status]').forEach(el=>{el.textContent=state.cafeOpen?config.open:config.closed_status;});
    document.querySelectorAll('[data-pad-order-message]').forEach(el=>{el.textContent=state.reason;el.hidden=!state.reason;});
    document.querySelectorAll('[data-pad-order-action]').forEach(el=>{
      const busy=el.closest('form')?.getAttribute('aria-busy')==='true';
      el.disabled=!state.accepts || el.dataset.padVariantUnavailable==='true' || busy;
      el.dataset.padHoursBlocked=String(!state.accepts);
    });
  }
  document.addEventListener('submit', event=>{
    const action=event.submitter;
    if (action?.matches('[data-pad-order-action]') && !serviceState().accepts) {event.preventDefault();event.stopImmediatePropagation();refresh();}
  },true);
  document.addEventListener('pad:variant-change',refresh);
  document.addEventListener('pad:commerce-settled',refresh);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
  document.addEventListener('shopify:section:load',refresh);
  refresh();setInterval(refresh,30000);

})();
